import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "w-3 mr-2"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mb-2 font-bold" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_10 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueToast = _resolveComponent("PrimeVueToast")!
  const _component_PrimeVueConfirmPopup = _resolveComponent("PrimeVueConfirmPopup")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_CreativeApprovalStatus = _resolveComponent("CreativeApprovalStatus")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_UserColumn = _resolveComponent("UserColumn")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!
  const _component_EntriesDataTable = _resolveComponent("EntriesDataTable")!
  const _component_FieldNumber = _resolveComponent("FieldNumber")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldDropdownAutoComplete = _resolveComponent("FieldDropdownAutoComplete")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_Entries = _resolveComponent("Entries")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PrimeVueToast, {
      position: "bottom-right",
      group: "bc"
    }, {
      message: _withCtx(({ message }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(message.detail.compiled_name), 1),
          _createElementVNode("div", _hoisted_3, [
            (message.detail.icon_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "w-full border-round-sm",
                    src: message.detail.icon_url
                  }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(message.detail.title), 1),
              _createElementVNode("div", null, _toDisplayString(message.detail.description), 1)
            ])
          ]),
          (message.detail.image_url)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "block mt-2 w-full border-round-sm",
                src: message.detail.image_url
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_PrimeVueConfirmPopup),
    _createVNode(_component_Entries, {
      title: _ctx.$t('creatives'),
      "href-prefix": "creatives"
    }, {
      "buttons:append": _withCtx(({ entriesLoading }) => [
        (_ctx.creativesFilters.trashed)
          ? _withDirectives((_openBlock(), _createBlock(_component_PrimeVueButton, {
              key: 0,
              class: "p-button-rounded p-button-outlined p-button-help ml-3 sm:ml-4",
              icon: "pi pi-trash",
              disabled: entriesLoading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.withTrashed(false)))
            }, null, 8, ["disabled"])), [
              [
                _directive_tooltip,
                'Hide deleted',
                void 0,
                { left: true }
              ]
            ])
          : _withDirectives((_openBlock(), _createBlock(_component_PrimeVueButton, {
              key: 1,
              class: "p-button-rounded p-button-outlined p-button-secondary opacity-30 ml-3 sm:ml-4",
              icon: "pi pi-trash",
              disabled: entriesLoading,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.withTrashed(true)))
            }, null, 8, ["disabled"])), [
              [
                _directive_tooltip,
                'Show deleted',
                void 0,
                { left: true }
              ]
            ])
      ]),
      tables: _withCtx(() => [
        _createVNode(_component_EntriesDataTable, {
          entries: _ctx.creatives,
          "entries-handler": _ctx.fetchCreatives,
          "href-prefix": "creatives"
        }, {
          actions: _withCtx(({ data, index }) => [
            _withDirectives(_createVNode(_component_PrimeVueButton, {
              class: "p-button-rounded p-button-text p-button-secondary",
              icon: "pi pi-eye",
              onClick: ($event: any) => (_ctx.previewCreative(data))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('preview'),
                void 0,
                { left: true }
              ]
            ]),
            (data.deleted_at)
              ? _withDirectives((_openBlock(), _createBlock(_component_PrimeVueButton, {
                  key: 0,
                  class: "p-button-rounded p-button-text p-button-success",
                  icon: _ctx.restoringCreativeId === data.id ? 'pi pi-spin pi-spinner' : 'pi pi-replay',
                  disabled: !!_ctx.restoringCreativeId,
                  onClick: ($event: any) => (_ctx.restoreCreative(data.id, () => _ctx.onRestoreSuccess(data.id)))
                }, null, 8, ["icon", "disabled", "onClick"])), [
                  [
                    _directive_tooltip,
                    'Restore',
                    void 0,
                    { left: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (!data.deleted_at)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.user.isStaff())
                    ? (_openBlock(), _createBlock(_component_CreativeApprovalStatus, {
                        key: 0,
                        "creative-id": data.id,
                        "creative-approval-status": _ctx.creatives.data[index].approval_status,
                        "onUpdate:creativeApprovalStatus": ($event: any) => ((_ctx.creatives.data[index].approval_status) = $event)
                      }, null, 8, ["creative-id", "creative-approval-status", "onUpdate:creativeApprovalStatus"]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createVNode(_component_PrimeVueButton, {
                    class: "p-button-rounded p-button-text p-button-secondary",
                    icon: _ctx.cloningCreativeId === data.id ? 'pi pi-spin pi-spinner' : 'pi pi-clone',
                    disabled: _ctx.cloningCreativeId === data.id,
                    onClick: ($event: any) => (_ctx.confirmCloneCreative($event, data.id, _ctx.onCloneSuccess))
                  }, null, 8, ["icon", "disabled", "onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('clone'),
                      void 0,
                      { left: true }
                    ]
                  ]),
                  _withDirectives(_createVNode(_component_PrimeVueButton, {
                    class: "p-button-rounded p-button-text p-button-danger",
                    icon: _ctx.deletingCreativeId === data.id ? 'pi pi-spin pi-spinner' : 'pi pi-trash',
                    disabled: !!_ctx.deletingCreativeId,
                    onClick: ($event: any) => (_ctx.confirmDeleteCreative($event, data.id, () => _ctx.onDeleteSuccess(data.id)))
                  }, null, 8, ["icon", "disabled", "onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('delete'),
                      void 0,
                      { left: true }
                    ]
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          columns: _withCtx(() => [
            _createVNode(_component_PrimeVueColumn, {
              field: "id",
              header: "ID",
              sortable: ""
            }),
            (_ctx.user.isSuperAdmin())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 0,
                  field: "project_id",
                  header: _ctx.$t('project'),
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.project.name), 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 1,
                  field: "user_id",
                  header: _ctx.$t('user'),
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_component_UserColumn, {
                      user: data.user,
                      "show-email-as-link": ""
                    }, null, 8, ["user"])
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            _createVNode(_component_PrimeVueColumn, {
              field: "type",
              header: _ctx.$t('type'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.CREATIVE_TYPES_MAP[data.type]?.label || '—'), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "image_format",
              header: "Format",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.CREATIVE_IMAGE_FORMATS_MAP[data.image_format]?.label || '—'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PrimeVueColumn, {
              field: "name",
              header: _ctx.$t('name'),
              sortable: ""
            }, null, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "approval_status",
              header: _ctx.$t('approval_status'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_PrimeVueTag, {
                  value: _ctx.$t(_ctx.CREATIVE_APPROVAL_STATUSES_MAP[data.approval_status].translate_key),
                  severity: _ctx.CREATIVE_APPROVAL_STATUSES_MAP[data.approval_status].severity
                }, null, 8, ["value", "severity"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "updated_at",
              header: _ctx.$t('updated_at'),
              sortable: ""
            }, null, 8, ["header"])
          ]),
          _: 1
        }, 8, ["entries", "entries-handler"])
      ]),
      filters: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_FieldNumber, {
            modelValue: _ctx.creativesFilters.id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.creativesFilters.id) = $event)),
            modelModifiers: { number: true },
            label: "ID"
          }, null, 8, ["modelValue"])
        ]),
        (_ctx.user.isSuperAdmin())
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.creativesFilters.project_id,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.creativesFilters.project_id) = $event)),
                  _ctx.onProjectChange
                ],
                modelModifiers: { number: true },
                label: _ctx.$t('project'),
                loading: _ctx.projectsLoading,
                "show-clear": true,
                options: _ctx.projects.data,
                "option-value": "id",
                "option-label": "name"
              }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.user.isStaff())
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_FieldDropdownAutoComplete, {
                modelValue: _ctx.creativesFilters.user_id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.creativesFilters.user_id) = $event)),
                modelModifiers: { number: true },
                name: "user_id",
                label: _ctx.$t('user'),
                "show-clear": "",
                "api-url": "/api/v3/users/options",
                "api-params": _ctx.usersParams,
                "option-label": "compiled_name"
              }, null, 8, ["modelValue", "label", "api-params"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.creativesFilters.type,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.creativesFilters.type) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('type'),
            "show-clear": true,
            options: _ctx.CREATIVE_TYPES
          }, null, 8, ["modelValue", "label", "options"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.creativesFilters.image_format,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.creativesFilters.image_format) = $event)),
            label: "Format",
            "show-clear": true,
            options: _ctx.CREATIVE_IMAGE_FORMATS
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_FieldText, {
            modelValue: _ctx.creativesFilters.name,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.creativesFilters.name) = $event)),
            modelModifiers: { trim: true },
            label: _ctx.$t('name')
          }, null, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.creativesFilters.approval_status,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.creativesFilters.approval_status) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('approval_status'),
            "show-clear": true,
            options: _ctx.CREATIVE_APPROVAL_STATUSES,
            "option-label-translate": ""
          }, null, 8, ["modelValue", "label", "options"])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}